import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import PropTypes from 'prop-types';

import {
  Icon,
  CircleTimer,
} from 'shared/components';
import { SECOND } from 'shared/utils/timeConstants';

import theme from './LockdownForm.scss';

const propTypes = {
  finishLockdown: PropTypes.func.isRequired,
  secondsLeft: PropTypes.number.isRequired,
  totalLockdownSeconds: PropTypes.number.isRequired,
  setSecondsLeft: PropTypes.func.isRequired,
};

const defaultProps = {};
const secondsToMinutes = seconds => Math.ceil(seconds / 60);

const LockdownForm = ({
  finishLockdown,
  secondsLeft,
  totalLockdownSeconds,
  setSecondsLeft,
}) => {
  if (secondsLeft <= 0) {
    finishLockdown();
    return null;
  }

  return (
    <div className={ theme.root }>
      <Icon className={ theme.lockdownIcon } name="lockdown" />

      <h3 className={ theme.subtitle }>
        <FormattedHTMLMessage
          id="Authentication.Lockdown.Error.ExceededNumAttempts"
          defaultMessage="** You exceeded the number of allowed attempts. Please wait {minutesLeft,number} {minutesLeft,plural, one{minute} other{minutes}} to try again"
          values={{ minutesLeft: secondsToMinutes(secondsLeft) }}
        />
      </h3>

      { (secondsLeft > 0) && (
        <CircleTimer
          testId="lockdown-circle-timer"
          defaultValue={ secondsLeft }
          ticksAmount={ totalLockdownSeconds }
          intervalBetweenTicks={ SECOND }
          reverse={ true }
          onComplete={ finishLockdown }
          onChange={ setSecondsLeft }
          timeValueFormatter={ secondsToMinutes }
        />
      ) }
    </div>
  );
};

LockdownForm.propTypes = propTypes;
LockdownForm.defaultProps = defaultProps;

export default LockdownForm;
